import { render } from "./SupportRequestForm.vue?vue&type=template&id=9891d528&ts=true"
import script from "./SupportRequestForm.vue?vue&type=script&lang=ts"
export * from "./SupportRequestForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__